var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "box" } },
    [
      _c(
        "a-card",
        {
          staticStyle: {
            "box-sizing": "border-box",
            "border-radius": "0 !important",
          },
        },
        [
          !_vm.appId
            ? _c("a-divider", [_vm._v("请选择应用APPID")])
            : _vm.noConfigText
            ? _c("a-divider", [_vm._v("您尚未配置任何支付方式")])
            : _vm._e(),
          _vm.payTestShow()
            ? _c(
                "div",
                { staticClass: "paydemo", staticStyle: { width: "100%" } },
                [
                  _c("Header"),
                  _c("div", { staticStyle: { height: "80px" } }),
                  _c(
                    "div",
                    { staticClass: "paydemo-type-content" },
                    [
                      _c(
                        "a-form-model",
                        {
                          ref: "form",
                          attrs: {
                            "label-col": { span: 5 },
                            model: _vm.form,
                            rules: _vm.rules,
                            "wrapper-col": { span: 18 },
                          },
                          on: { submit: _vm.handleSubmit },
                        },
                        [
                          _c(
                            "a-row",
                            [
                              _c("a-col", { attrs: { span: 1 } }, [
                                _c("div", {
                                  staticStyle: { width: "100%", height: "1px" },
                                }),
                              ]),
                              _c(
                                "a-col",
                                { attrs: { span: 11 } },
                                [
                                  _c(
                                    "a-form-model-item",
                                    { attrs: { label: "购买项目" } },
                                    [
                                      _vm._v(" 年服务费"),
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [_vm._v("￥" + _vm._s(_vm.tobonumber))]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "a-form-item",
                                    { attrs: { label: "购买年限/年" } },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          min: 1,
                                          max: 10,
                                          label: "描述文字",
                                        },
                                        model: {
                                          value: _vm.form.totalnum,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "totalnum", $$v)
                                          },
                                          expression: "form.totalnum",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-model-item",
                                    {
                                      attrs: {
                                        label: "购买单位",
                                        prop: "company",
                                      },
                                    },
                                    [
                                      _c("a-input", {
                                        staticStyle: { width: "70%" },
                                        attrs: {
                                          disabled: true,
                                          placeholder: "请输入购买单位全称",
                                        },
                                        model: {
                                          value: _vm.form.company,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "company", $$v)
                                          },
                                          expression: "form.company",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-model-item",
                                    {
                                      attrs: {
                                        label: "信用代码",
                                        prop: "yscode",
                                      },
                                    },
                                    [
                                      _c("a-input", {
                                        staticStyle: { width: "70%" },
                                        attrs: {
                                          disabled: true,
                                          placeholder: "请输入统一社会信用代码",
                                        },
                                        model: {
                                          value: _vm.form.yscode,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "yscode", $$v)
                                          },
                                          expression: "form.yscode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-item",
                                    { attrs: { label: "关于发票" } },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "red",
                                            cursor: "pointer",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "发票将在订单支付成功后3-5个工作日内发送到您填写的电子邮箱内。"
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c("a-col", { attrs: { span: 1 } }, [
                                _c("div", {
                                  staticStyle: { width: "100%", height: "1px" },
                                }),
                              ]),
                              _c("a-col", { attrs: { span: 11 } }, [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "flex-direction": "row",
                                        },
                                      },
                                      [
                                        _c("div", {
                                          staticStyle: {
                                            width: "9.8333%",
                                            height: "20px",
                                          },
                                        }),
                                        _c(
                                          "a-form-model-item",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "flex-direction": "row",
                                              "text-align": "left",
                                              "margin-left": "10px",
                                            },
                                            attrs: {
                                              "label-col": { span: 6 },
                                              "wrapper-col": { span: 24 },
                                              label: "证书卡号:",
                                              colon: false,
                                              required: true,
                                            },
                                          },
                                          [
                                            _c("a-input", {
                                              staticStyle: {
                                                width: "100%",
                                                "margin-left": "7px",
                                              },
                                              attrs: {
                                                placeholder: "请点击识别卡号",
                                                disabled: true,
                                              },
                                              model: {
                                                value: _vm.keysn,
                                                callback: function ($$v) {
                                                  _vm.keysn = $$v
                                                },
                                                expression: "keysn",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "shibie",
                                            staticStyle: { cursor: "pointer" },
                                            on: {
                                              click: _vm.handleSubmitmunber,
                                            },
                                          },
                                          [_vm._v("识别证书卡号")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-form-model-item",
                                      {
                                        attrs: {
                                          label: "电子邮箱",
                                          prop: "email",
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          staticStyle: { width: "70%" },
                                          attrs: {
                                            disabled: true,
                                            placeholder:
                                              "请输入用于接收电子发票有效邮箱，请使用网易或QQ邮箱",
                                          },
                                          model: {
                                            value: _vm.form.email,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form, "email", $$v)
                                            },
                                            expression: "form.email",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-form-model-item",
                                      {
                                        attrs: {
                                          label: "联系人",
                                          prop: "name",
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          staticStyle: { width: "70%" },
                                          attrs: {
                                            disabled: true,
                                            placeholder: "请输入联系人姓名",
                                          },
                                          model: {
                                            value: _vm.form.name,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form, "name", $$v)
                                            },
                                            expression: "form.name",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-form-model-item",
                                      {
                                        attrs: {
                                          label: "手机号码",
                                          prop: "phone",
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          staticStyle: { width: "70%" },
                                          attrs: {
                                            disabled: true,
                                            placeholder: "请输入11位手机号码",
                                          },
                                          model: {
                                            value: _vm.form.phone,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form, "phone", $$v)
                                            },
                                            expression: "form.phone",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "a-row",
                            {},
                            [
                              _c("a-col", { attrs: { span: 24 } }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "800px",
                                      margin: "auto",
                                      "text-align": "center",
                                    },
                                  },
                                  [
                                    _c(
                                      "a-form",
                                      {
                                        staticStyle: { "margin-left": "248px" },
                                        attrs: {
                                          id: "ok",
                                          form: _vm.form,
                                          "label-col": { span: 5 },
                                          "wrapper-col": { span: 12 },
                                        },
                                      },
                                      [
                                        _c(
                                          "a-form-item",
                                          { attrs: { label: "" } },
                                          [
                                            _c("a-checkbox", {
                                              staticStyle: {
                                                "margin-right": "10px",
                                              },
                                              on: { change: _vm.onChangeqw },
                                              model: {
                                                value: _vm.checked,
                                                callback: function ($$v) {
                                                  _vm.checked = $$v
                                                },
                                                expression: "checked",
                                              },
                                            }),
                                            _vm._v(" 我已认真阅读并 "),
                                            _c(
                                              "span",
                                              {
                                                style: _vm.radioStyle,
                                                on: { click: _vm.boglook },
                                              },
                                              [_vm._v("同意协议")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row",
                            "justify-content": "center",
                            "padding-top": "10px",
                          },
                        },
                        [
                          _vm.companyinfostatus
                            ? _c(
                                "a-button",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    width: "200px",
                                    height: "40px",
                                    "font-size": "15px",
                                  },
                                  attrs: { type: "danger" },
                                  on: { click: _vm.login },
                                },
                                [_vm._v("登录后提交订单")]
                              )
                            : _vm._e(),
                          !_vm.companyinfostatus
                            ? _c(
                                "a-button",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    width: "200px",
                                    height: "40px",
                                    "font-size": "15px",
                                  },
                                  attrs: {
                                    disabled: _vm.disabledlook,
                                    type: "danger",
                                  },
                                  on: { click: _vm.handleSubmit },
                                },
                                [_vm._v(" 提交订单 ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row",
                            "justify-content": "center",
                            color: "#132b75",
                            "line-height": "50px",
                            cursor: "pointer",
                          },
                          on: { click: _vm.homepay },
                        },
                        [_vm._v("返回首页")]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row",
                            "align-items": "center",
                            "justify-content": "center",
                          },
                          attrs: { id: "bottomtoolbar" },
                        },
                        [
                          _c("div", { attrs: { id: "sealintro" } }, [
                            _c("div", [
                              _vm._v(" 本服务购买后"),
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v("不可退款"),
                              ]),
                              _vm._v("，敬请理解！ "),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: { title: "流程说明", width: "40%" },
          on: { ok: _vm.handleOkmodd },
          model: {
            value: _vm.visiblemodd,
            callback: function ($$v) {
              _vm.visiblemodd = $$v
            },
            expression: "visiblemodd",
          },
        },
        [
          _c("p", [
            _c("b", [
              _vm._v(
                "灌装流程说明：企业在此下单后，前往证书运维管理平台上自助抠账使用。"
              ),
            ]),
          ]),
          _c("p", [_vm._v("Some contents...")]),
          _c("p", [_vm._v("Some contents...")]),
        ]
      ),
      _c("pay-test-modal", {
        ref: "payTestModal",
        on: {
          closeBarCode: function ($event) {
            _vm.$refs.payTestBarCode.visible = false
          },
        },
      }),
      _c("pay-test-bar-code", {
        ref: "payTestBarCode",
        on: {
          CodeAgainChange: _vm.testCodeChange,
          barCodeValue: _vm.barCodeChange,
        },
      }),
      _c("Footer"),
      _c(
        "a-modal",
        {
          attrs: {
            "confirm-loading": _vm.confirmLoading,
            destroyOnClose: true,
            maskClosable: false,
            visible: _vm.visible,
            title: "阅读条款",
            width: "45%",
          },
          on: { cancel: _vm.handleCancel },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      staticClass: "footerbutton",
                      attrs: { disabled: _vm.disabled, type: "primary" },
                      on: { click: _vm.handleOk },
                    },
                    [_vm._v(_vm._s(_vm.valiBtn) + " ")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_c("Contract", { attrs: { Fathertoson: _vm.Fathertoson } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }